export const GOOGLE_MAPS_LIBRARIES = ['places', 'geometry'] as any[]
